module.exports = __webpack_public_path__ + "static/media/audio-05-ru.09b00a92.mp3";